import system from './system'
import org from './org'
import dict from './dict'
import user from './user'
import menu from './menu'
import url from './url'
import role from './role'
import functions from './functions'

export default {
  base: {
    info: {
      ...system,
      ...org,
      ...dict,
      ...user,
      ...menu,
      ...url,
      ...role,
      ...functions
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/base.js